import React, { useState, useEffect } from "react";
import axios from "axios";
import Main from "./Main";
import "./App.scss";
import { URL } from "./constants/url";

function App() {
  const [dataPrices, setDataPrices] = useState({});
  const [dataProducts, setDataProducts] = useState({});

  useEffect(() => {
    // Fetch data when component mounts
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const priceResponse = await axios.get(`${URL}/api/prices`);
      const productResponse = await axios.get(`${URL}/api/products`);

      setDataPrices(priceResponse.data);
      setDataProducts(productResponse.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  return (
    <div className="App">
      <AppContext.Provider value={{ dataPrices, dataProducts }}>
        <Main />
      </AppContext.Provider>
    </div>
  );
}

export const AppContext = React.createContext();

export default App;
